// Library form Type taxonomy (TAX-01). Tag/filter only in v1.
// Keep domain values here — never inline 'diy'/'difm' in components (code-standards F4).

export const LIBRARY_FORM_TYPES = {
  DIY: 'diy',
  DIFM: 'difm',
};

export const LIBRARY_FORM_TYPE_OPTIONS = [
  { value: LIBRARY_FORM_TYPES.DIY, label: 'DIY (Do It Yourself)' },
  { value: LIBRARY_FORM_TYPES.DIFM, label: 'DIFM (Do It For Me)' },
];

export const getLibraryFormTypeLabel = (type) => {
  const option = LIBRARY_FORM_TYPE_OPTIONS.find((opt) => opt.value === type);
  return option ? option.label : (type || '-');
};

// Tag colour per type for the list rendering.
export const LIBRARY_FORM_TYPE_COLORS = {
  [LIBRARY_FORM_TYPES.DIY]: 'green',
  [LIBRARY_FORM_TYPES.DIFM]: 'blue',
};
